import { StylingModel } from '../style/styling.model';
import { CoreStylingModel } from '../core/core-styling.model';
import { IconStylingModel } from '../icon/icon-styling.model';
export class DatatableStylingModel extends CoreStylingModel {
/**
 * Styling of header by StylingModel
 */
header?: StylingModel;
/**
 * Styling of table by StylingModel
 */
table?: StylingModel;
/**
 * Styling of tableCell by StylingModel
 */
tableCell?: StylingModel;
/**
 * Styling of tableRowDetails by StylingModel
 */
tableRowDetails?: StylingModel;
/**
 * Styling of expandIcon by IconStylingModel
 */
expandIcon?: IconStylingModel;
/**
 * Styling of collapseIcon by IconStylingModel
 */
collapseIcon?: IconStylingModel;
/**
 * Styling of footer by StylingModel
 */
footer?: StylingModel;
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function DatatableStylingModel_tsickle_Closure_declarations() {
/**
 * Styling of header by StylingModel
 * @type {?}
 */
DatatableStylingModel.prototype.header;
/**
 * Styling of table by StylingModel
 * @type {?}
 */
DatatableStylingModel.prototype.table;
/**
 * Styling of tableCell by StylingModel
 * @type {?}
 */
DatatableStylingModel.prototype.tableCell;
/**
 * Styling of tableRowDetails by StylingModel
 * @type {?}
 */
DatatableStylingModel.prototype.tableRowDetails;
/**
 * Styling of expandIcon by IconStylingModel
 * @type {?}
 */
DatatableStylingModel.prototype.expandIcon;
/**
 * Styling of collapseIcon by IconStylingModel
 * @type {?}
 */
DatatableStylingModel.prototype.collapseIcon;
/**
 * Styling of footer by StylingModel
 * @type {?}
 */
DatatableStylingModel.prototype.footer;
}

